export enum BlockedType {
  NEGATIVE_BALANCE = 'nuvempago-negativebalance-blocking',
  SRE = 'nuvempago-sre-blocking',
}
